import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';

export const ResponsiveImage = ({
  src,
  alt,
  className,
  ...restOfProps
}) => (
  <img
    alt={alt}
    src={src}
    className={clsx(className, 'ss_responsive-image')}
    {...restOfProps}
  />
);

ResponsiveImage.defaultProps = {
  className: '',
};
ResponsiveImage.propTypes = {
  alt: PropTypes.string.isRequired,
  src: PropTypes.string.isRequired,
  className: PropTypes.string,
};

export default ResponsiveImage;
